export enum PricingTypes {
  Free = 1,
  Paid,
  Other,
}
